fragment SingleSocialMediaPostFragment on singleSocialMediaPost_Entry {
  typeHandle
  postLink
}
